<template>
    <div class="bid-pro">
        <div class="bid-pro-top">
            <!-- 背景图 -->
            <div class="bid-inner">
                <div class="bid-title">招标采购电子交易解决方案</div>
                <div class="bid-bg"></div>
                <a class="gogg" href="http://www.hbidding.com" target="_blank">
                    进入产品官网
                    <i class="el-icon-sort-down"></i>
                </a>
            </div>
        </div>

        <div class="bid-cont">
            <div class="bid-cont-top">
                <div class="inner">
                    <p class="title">{{ bidText.title }}</p>
                    <p>{{ bidText.p1 }}</p>
                </div>
            </div>
            <div class="bid-cont-bot inner">
                <p class="title">资质</p>
                <div class="zizhi">
                    <div>
                        <img :src="zizhi1" alt="" />
                        <p>三星级平台</p>
                    </div>
                    <div>
                        <img :src="zizhi2" alt="" />
                        <p>三级等保平台</p>
                    </div>

                    <div class="zizhi-box">
                        <img :src="item.img ? item.img : ''" v-for="(item, index) in zizhi" :key="index" />
                        <p>多项软件著作权</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bid-bot">
            <div class="title">业务范围</div>
            <businessList></businessList>
        </div>
    </div>
</template>

<script>
import businessList from './components/business-list.vue';
import CONFIG_PROJECT from '@config/project';

export default {
    head: {
        title: `产品和服务·${CONFIG_PROJECT.title}`,
    },
    name: '',
    components: { businessList },
    data() {
        return {
            bidText: {
                title: '招标采购电子交易解决方案',
                p1: '国内领先的招标采购数智化整体解决方案。电子招标投标交易平台（惠招标）是中惠科技独立研发并运营的第三方电子交易平台。早在2015年就已成为国家发改委电子招投标交易系统试点单位，同时在河北省开展试点工作。拥有全套完整源代码，并取得软件著作权证书，较早取得国家三星级检测认证证书，并取得公安网络系统等保三级证书。截至2022年，惠招标平均每日投标量达1000+次，项目数量远超省内其他第三方交易平台。',
            },
            zizhi1: '/images/products/bid-pro/zz-1.png',
            zizhi2: '/images/products/bid-pro/zz-2.png',
            zizhi: [
                { img: '/images/products/bid-pro/zz-3-1.png' },
                { img: '/images/products/bid-pro/zz-3-2.png' },
                { img: '/images/products/bid-pro/zz-3-3.png' },
                { img: '/images/products/bid-pro/zz-3-4.png' },
                { img: '/images/products/bid-pro/zz-3-5.png' },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.bid-pro {
    background-color: #fff;
    width: 100%;
    // height: 1600px;
    position: relative;
    .bid-pro-top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: url('/images/products/erji-bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;

        .bid-inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            .bid-title {
                width: 600px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bid-bg {
                z-index: 10;
                position: absolute;
                top: 30px;
                right: 100px;

                width: 350px;
                height: 300px;
                background: url('/images/products/bid-pro/bg-1.png') no-repeat;
                background-size: 100% 100%;
                background-size: cover;
            }

            .gogg {
                color: #fff;
                font-size: 14px;
                width: 140px;
                height: 30px;
                border: 1px solid #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 170px;
                left: 0;
                cursor: pointer;
                &:hover {
                    color: #8a1f94;
                    border: 1px solid #8a1f94;
                }

                i {
                    display: inline-block;
                    transform: rotate(90deg) scaleY(-1);
                }
            }
        }
    }

    .bid-cont {
        // width: 1200px;
        // margin: 70px auto 0;

        .bid-cont-top {
            // height: 240px;
            width: 100%;
            // margin-bottom: 70px;
            padding: 70px 0 50px;
            // box-shadow: 0 0 10px rgb(173, 173, 173);
            background-color: #f6fbfe;
            p {
                font-size: 15px;
                color: #131415;
                text-align: center;
            }
            .title {
                margin-bottom: 30px;
                font-size: 24px;
                // font-weight: bold;
                color: #131415;
            }
        }

        .bid-cont-bot {
            .title {
                font-size: 36px;
                text-align: center;
                margin: 50px 0;
                font-weight: 600;
            }
            .zizhi {
                width: 100%;
                // height: 300px;
                // padding: 0 60px;
                margin-bottom: 30px;
                display: flex;
                justify-content: space-between;
                // flex-wrap: wrap;

                img {
                    cursor: pointer;
                    transition: all 0.3s;
                    &:hover {
                        transform: scale(1.1);
                    }
                }
                p {
                    margin: 10px 0;
                    font-size: 16px;
                }

                .zizhi-box {
                    width: 174px;
                    height: 263px;
                    margin-right: 236px;
                    background-color: #f5fbff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    img {
                        height: 260px;
                        width: 195px;
                        margin-right: -250px;
                    }
                    p {
                        width: 120px;
                        display: inline-block;
                        position: absolute;
                        bottom: -50px;
                        right: -100px;
                    }
                }
                & > div {
                    text-align: center;
                }
            }
        }
    }

    .bid-bot {
        width: 100%;
        min-height: 580px;
        // background-color: #f6fbfe;

        .title {
            text-align: center;
            width: 1200px;
            margin: 0 auto;
            padding: 30px 0 30px;
            font-size: 36px;
            font-weight: 600;
            color: #131415;
        }
        .my-tabs {
            width: 1200px;
            height: 400px;
            margin: 0 auto;
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
